<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button routerLink="/">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      &nbsp;About
    </ion-title>
  </ion-toolbar>
</ion-header>
      
<ion-content class="ion-padding ion-text-center">
    <br/><br/>
    <img src="/assets/imgs/Knutsen_family-01-sm.jpg"  routerLink="/" />
    <br/>
    <h1>Guitar (Open) Tuning Reference</h1>
    <h3 [style.margin-top]="'0px'">
      {{ tuningsTextService.all.length }} six-strings guitar tunings
    </h3>
    <br/>
    <h5 [style.margin-top]="'0px'">
      <a href="http://jpglomot.com">http://jpglomot.com</a>
      - June 2026</h5>
    <br/><br/>
    <br/>
    <br/>
    <!-- div class="content">
        <ul class="chapter">
        <li *ngFor="let chapter of tuningsService.chapters; let i = index"
            [routerLink]="['/content', i]">
            <span class="badge">{{chapter.id}}</span> {{chapter.title}}
        </li>
        </ul>
    </div>
    <br/ -->
</ion-content>
